var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCanadainline = function SvgCanadainline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 0h21.229v30H4.75V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.86 0H4.753v30H-5.86V0Zm31.84 0h10.612v30H25.98V0ZM7.928 14.496l-.82.281 3.832 3.37c.292.867-.1 1.119-.352 1.576l4.16-.528-.105 4.19.867-.03-.194-4.154 4.172.492c-.258-.545-.486-.832-.252-1.699l3.832-3.193-.668-.24c-.55-.428.235-2.04.352-3.059 0 0-2.232.768-2.379.363l-.58-1.084-2.027 2.227c-.223.058-.317-.035-.37-.223l.938-4.67-1.488.838c-.123.053-.246 0-.328-.14L15.082 5.94l-1.477 2.983c-.11.105-.222.117-.316.047l-1.418-.797.85 4.64c-.065.176-.229.235-.416.135l-1.951-2.215c-.252.41-.428 1.079-.762 1.23-.334.136-1.465-.286-2.22-.45.257.931 1.066 2.478.556 2.988v-.006Z",
    fill: "#D52B1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#fff"
  })))));
};
export default SvgCanadainline;